import environment from "../../../../environments/environment";
import { axiosInterceptor } from "../authInterceptor";

const FISCAL_BASE_URL = environment.fiscalBaseURL

interface PartTypes {
  page:number
  size:number
  isActive:string
}


export async function getAllParticipants(partcipantDetails:PartTypes) {
  try{
    const getParticipantsDetails= await axiosInterceptor.post(`${FISCAL_BASE_URL}participants/filter`,partcipantDetails); 
    return { data: getParticipantsDetails, error: undefined };
  } catch (error: any) {
    const errorMessage = error.response || 'An error occurred';
    return { data: undefined, error: errorMessage };
  }
  
}